const ENDPOINT = 'https://prod-39.northeurope.logic.azure.com:443/workflows/f5fe7b4720c349c5b2a8473ee93e8057/triggers/manual/paths/invoke?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=7bsYikIYipJB2NKPsod59Ivm5nUdduz4eukfYw31B-0';
const REQUEST_TIMEOUT_MS = 10000;

document.addEventListener('DOMContentLoaded', function () {
  const form = document.getElementById('lookup-form');
  const result = document.getElementById('lookup-result');
  if (!form || !result) return;

  const button = form.querySelector('button[type="submit"]');

  function showMessage(text) {
    result.textContent = text;
  }

  function showResult(data) {
    result.replaceChildren();

    const message = document.createElement('p');
    message.textContent = data.message;

    const deliveryAddressHeader = document.createElement('strong');
    deliveryAddressHeader.textContent = "Delivery address: ";
    const shippingModelHeader = document.createElement('strong');
    shippingModelHeader.textContent = "Shipping model: ";

    const shipToAddress1 = document.createElement('p');
    shipToAddress1.textContent = data.shipToStreet1;
    const shipToAddress2 = document.createElement('p');
    shipToAddress2.textContent = data.shipToStreet2;
    const shipToPostCode = document.createElement('p');
    shipToPostCode.textContent = data.shipToPostCode;
    const shipToCity = document.createElement('p');
    shipToCity.textContent = data.shipToCity;
    const shipToCountry = document.createElement('p');
    shipToCountry.textContent = data.shipToCountry;

    const shopifyShipping = document.createElement('p');
    shopifyShipping.textContent = data.shopifyShipping;

    result.append(message);

    if (data.statusCode != "NOT_FOUND") {
        result.append(deliveryAddressHeader);
        result.append(shipToAddress1);
        result.append(shipToAddress2);
        result.append(shipToPostCode);
        result.append(shipToCity);
        result.append(shipToCountry);
        result.append(shippingModelHeader);
        result.append(shopifyShipping);
    }
  }

  function readPayload() {
    const orderId = document.getElementById('lookup-order-id').value.trim();
    const email = document.getElementById('lookup-email').value.trim();

    return {
        orderNumber: orderId,
        email: email,
        language: "en",
        shop: "dk"
        };
  }

  form.addEventListener('submit', async function (e) {
    e.preventDefault();

    const payload = readPayload();

    button.disabled = true;
    showMessage('Loading…');

    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), REQUEST_TIMEOUT_MS);

    try {
      const res = await fetch(ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
        signal: controller.signal
      });

      if (!res.ok) throw new Error('HTTP ' + res.status);

      const data = await res.json();

      showResult(data);
    } catch (err) {
      console.error('Lookup form:', err);
      showMessage(err.name === 'AbortError'
        ? 'The request timed out. Please try again.'
        : 'Something went wrong. Please try again.');
    } finally {
      clearTimeout(timer);
      button.disabled = false;
    }
  });
});